import "core-js/modules/es.array.includes.js";
import styled, { css } from 'styled-components';
import { visuallyHidden } from 'styles/mixins';
import Box from 'components/Box';

// Hidden component must be called with either one (or both) of the `above` or `below` props

function getBreakpoint(key, theme) {
  var _theme$globals$breakp;
  return ((_theme$globals$breakp = theme.globals.breakpoints) === null || _theme$globals$breakp === void 0 ? void 0 : _theme$globals$breakp[key]) || key;
}
var propsToFilter = ['above', 'below', 'accessible'];
var Hidden = styled(Box).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !propsToFilter.includes(prop);
  }
}).withConfig({
  displayName: "Hidden",
  componentId: "sc-10el5r1-0"
})(["", " ", ""], function (p) {
  return p.below && css(["@media (max-width:", "){", "}"], getBreakpoint(p.below, p.theme), p.accessible ? visuallyHidden : "display: none;");
}, function (p) {
  return p.above && css(["@media (min-width:", "){", "}"], getBreakpoint(p.above, p.theme), p.accessible ? visuallyHidden : "display: none;");
});
Hidden.displayName = 'Hidden';
export default Hidden;